var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value && _vm.value.html)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.value.html)}}):(_vm.value)?_c('p',[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }